module.exports = __webpack_public_path__ + "img/cup.7ec07a18.png";